import React from 'react';

import { Button, Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import EditorialQuote from '../../components/public/EditorialQuote.component';
import EditorialSteps from '../../components/public/EditorialSteps.component';
import {
  ECO_POINTS_EQUATION,
  ECO_POINTS_EXAMPLE,
  ECO_POINTS_HERO,
  ECO_POINTS_TESTIMONIALS,
  ECO_POINTS_TESTIMONIALS_TITLE,
} from '../../constants/eco-points-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '2rem',
    textAlign: 'center',
    color: theme.palette.client.primary.extraDark,
  },
  cta: {
    display: 'block',
    margin: '2.5rem auto 0',
    color: theme.palette.client.accent.main,
    fontWeight: 600,
  },
}));

const EcoPointsView: React.FC = () => {
  const classes = useStyles();

  const renderCta = () => {
    // Sans destination, le bouton reste un bouton : il ne doit produire aucun lien mort.
    if (!ECO_POINTS_EQUATION.ctaPath) {
      return (
        <Button className={classes.cta} disableRipple>
          {ECO_POINTS_EQUATION.ctaLabel}
        </Button>
      );
    }

    return (
      <Button className={classes.cta} component={Link} to={ECO_POINTS_EQUATION.ctaPath}>
        {ECO_POINTS_EQUATION.ctaLabel}
      </Button>
    );
  };

  return (
    <React.Fragment>
      <Meta page="ecopoint" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero title={ECO_POINTS_HERO.title} highlight={ECO_POINTS_HERO.highlight} />
      </EditorialBand>

      <EditorialBand ground="plain">
        <Typography component="h2" className={classes.sectionTitle}>
          {ECO_POINTS_EXAMPLE.title}
        </Typography>

        <EditorialSteps steps={ECO_POINTS_EXAMPLE.steps} />
      </EditorialBand>

      <EditorialBand ground="tint">
        <Typography component="h2" className={classes.sectionTitle}>
          {ECO_POINTS_EQUATION.title}
        </Typography>

        <EditorialSteps steps={ECO_POINTS_EQUATION.steps} />

        {renderCta()}
      </EditorialBand>

      <EditorialBand ground="plain">
        <Typography component="h2" className={classes.sectionTitle}>
          {ECO_POINTS_TESTIMONIALS_TITLE}
        </Typography>

        {/* `alignItems="stretch"` avec le `height: 100%` de la carte aligne le bas des quatre
            témoignages, dont les longueurs diffèrent sensiblement. */}
        <Grid container spacing={3} alignItems="stretch">
          {ECO_POINTS_TESTIMONIALS.map((testimonial) => (
            <Grid item xs={12} md={6} key={testimonial.author}>
              <EditorialQuote content={testimonial} orientation="stacked" />
            </Grid>
          ))}
        </Grid>
      </EditorialBand>
    </React.Fragment>
  );
};

export default EcoPointsView;
